'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var Shell = require('./Shell.jsx');
var DesktopShell = require('./DesktopShell.jsx');
var MainStage = require('./MainStage.jsx');
var pageHelper = require('../helper/pageHelper');
var Comments = require('./Comments.jsx');

var CommentCover = require('./Review/CommentCover');

var Workspace = React.createClass({
  propTypes: {
    domSize: React.PropTypes.object.isRequired,
    meta: React.PropTypes.object.isRequired,
    pages: React.PropTypes.object,
    current: React.PropTypes.object.isRequired,
    target: React.PropTypes.object,
    animation: React.PropTypes.object,
    app: React.PropTypes.object.isRequired,
    showComments: React.PropTypes.bool.isRequired,
    scale: React.PropTypes.number.isRequired,
    shell: React.PropTypes.string.isRequired,
    canFix: React.PropTypes.bool.isRequired,
    onRedirectTo: React.PropTypes.func.isRequired,
    onOpenPage: React.PropTypes.func.isRequired,
    onFinishOpenPage: React.PropTypes.func.isRequired,
    onShowRemark: React.PropTypes.func.isRequired,
    alwaysShowLinks: React.PropTypes.bool.isRequired,
    hintLinks: React.PropTypes.bool.isRequired,
    scrollRemarks: React.PropTypes.bool.isRequired,
    pageNeedRerender: React.PropTypes.bool.isRequired,
    isCommentMode: React.PropTypes.bool.isRequired,
    review: React.PropTypes.array.isRequired,
    isShowPaint: React.PropTypes.bool.isRequired,
    onLoadReviewData: React.PropTypes.func.isRequired,
  },


  componentWillReceiveProps: function (nextProps) {
    if (this.props.current.ID !== nextProps.current.ID) {
      var scrollDom = ReactDOM.findDOMNode(this.refs.scroll);
      if (scrollDom) {
        scrollDom.scrollTop = 0;
        scrollDom.scrollLeft = 0;
      }
      this._onPageScroll(0);
      this.setState({pageScrollTop: 0, isNeedReloadReview: true});
    } else {
      this.setState({isNeedReloadReview: false});
    }
  },

  componentDidMount: function () {
    this.commentsScroller = $("#comments-scroller");
    this.doReloadReviewData();


    var scrollContentDom = ReactDOM.findDOMNode(this.refs.scrollContent);
    console.log(scrollContentDom.clientWidth);
    var scrollContent = {
      width: scrollContentDom.clientWidth,
      height: scrollContentDom.clientHeight
    };
    console.log(scrollContent);
    this.setState({
      scrollContent: scrollContent
    })
  },

  doReloadReviewData: function() {
    if(this.state.isNeedReloadReview) {
      var syncID = window.reviewID || '';
      var syncRevision = window.revision || '-1';
      this.props.onLoadReviewData(syncID, syncRevision, this.props.current.ID);
    }
  },

  componentDidUpdate: function() {
    var pageOffset = $('.stage-container').offset();
    var coverOffset = $('.paint-stage').offset();

    if(pageOffset && coverOffset) {
      var offset = {
        left: pageOffset.left - coverOffset.left,
        top: pageOffset.top - coverOffset.top - (this.state.pageScrollTop || 0)
      };
      if(!this.state.offset || offset.left !== this.state.offset.left || offset.top !== this.state.offset.top) {
        this.setState({offset: offset})
      }
    }

    this.doReloadReviewData();
  },

  getInitialState: function() {
    return {
      offset: null,
      pageScrollTop: 0,
      isNeedReloadReview: true,
      scrollContent: {
        width: 0,
        height: 0
      }
    }
  },

  render: function () {

    var page = this.props.current;
    var target = this.props.target;
    var commentComponents;
    var pageInfo = pageHelper.getPageDeviceMetaInfo(page, this.props.meta, this.props.shell);
    var deviceStyle = {
      width: pageInfo.width,
      height: pageInfo.height,
      transform: 'scale(' + this.props.scale + ')'
    };

    var screenSize = {
      width: pageInfo.pageSize.x,
      height: pageInfo.pageSize.y
    };

    var deviceScrollStyle = {
      width: Math.round(6000 * this.props.scale), // 设置为 6000 让滚动条显示到上面
      height: Math.round(pageInfo.height * this.props.scale)
    };

    var deviceScrollViewStyle = {};
    if (pageInfo.height * this.props.scale < this.props.domSize.height) {
      if (this.props.meta.platform === 'MtWeb') { // 网页项目，垂直使用居顶
        deviceScrollViewStyle.alignItems = 'flex-start';
      } else {
        deviceScrollViewStyle.alignItems = 'center';
      }
    } else {
      deviceStyle.transformOrigin = 'top left'; // 此时从左上角放大
    }

    commentComponents = _.filter(page.controls.control, function (comp) {
      return comp.isCommentCom;
    });

    var className = 'preview-container';

    /*显示类型检测*/
    var shellType = this.props.shell;
    if (shellType === 'iPad') {
      deviceStyle.transformOrigin = 'left top';
    } else if (shellType === 'iPhone') {
      deviceStyle.transformOrigin = 'center top';
    } else if (shellType === 'desktop') {
      deviceStyle.transformOrigin = 'left top';
    } else {
      deviceStyle.transformOrigin = 'left top';
    }
    if (this.props.meta.platform === 'MtWeb') {    //网页项目，顶部居中放缩
      deviceStyle.transformOrigin = 'center top';
    }

    var syncID = window.reviewID || '';
    var syncRevision = window.revision || '-1';
    return (
      <div className={className} onClick={this._onWorkspaceClick}>
        <div className="device-scroll-view" ref="scroll" style={deviceScrollViewStyle}>
          <div className="device-scroll-content" ref="scrollContent" style={deviceScrollStyle}>
            <div id='device' className="device" style={deviceStyle}>
              {
                ['iPhone', 'Android', 'iPad', 'Tablet'].indexOf(this.props.shell) !== -1 &&
                <Shell
                  size={{
                    width: pageInfo.width,
                    height: pageInfo.height,
                    left: pageInfo.position.x,
                    top: pageInfo.position.y
                  }}
                  shell={this.props.shell}
                  isHorizontal={pageInfo.isHorizontal}
                />
              }
              {
                this.props.shell === 'desktop' &&
                <DesktopShell
                  size={{
                    width: pageInfo.width,
                    height: pageInfo.height
                  }}
                  title={page.title}
                />
              }
              <MainStage
                position={pageInfo.position}
                size={screenSize}
                current={page}
                target={target}
                animation={this.props.animation}
                pages={this.props.pages}
                showComments={this.props.showComments}
                canFix={this.props.canFix}
                onRedirectTo={this.props.onRedirectTo}
                onOpenPage={this.props.onOpenPage}
                onFinishOpenPage={this.props.onFinishOpenPage}
                onPageScroll={this._onPageScroll}
                onShowRemark={this.props.onShowRemark}
                orientation={this.props.meta.orientation}
                onClick={this.handleClick}
                pageNeedRerender={this.props.pageNeedRerender}
                onPageScroll={this.onPageScroll}
              />
              <Comments
                position={pageInfo.position}
                components={commentComponents}
                show={this.props.showComments}
                pageScrollTop={this.state.pageScrollTop}
              />
            </div>
            {
              this.props.isShowPaint &&
              <CommentCover

                scrollLeft={0}
                review={this.props.review}
                fullPageLocation={this.state.offset}

                syncID={syncID}
                syncVersion={syncRevision}
                ID={this.props.current.ID}

                onLoadReviewData={this.props.onLoadReviewData}
                scrollContent={this.state.scrollContent}
              />
            }
          </div>
        </div>
      </div>
    );
  },

  onPageScroll: function(top, left) {
    this.setState({pageScrollTop: top});
  },

  _onPageScroll: function (scrollTop) {
    if (this.props.scrollRemarks) { // 只有当设置中允许滚动批注组件，才滚动批注组件
      this.commentsScroller && this.commentsScroller.css('top', -scrollTop);
    }
  },

  _onWorkspaceClick: function (e) {
    if (!this.props.alwaysShowLinks && this.props.hintLinks) {
      $('.preview-container').addClass('click-show-links');
      setTimeout(function () {
        $('.preview-container').removeClass('click-show-links');
      }, 800);
    }
    e.stopPropagation();
    e.preventDefault();
    $('.page').trigger('onScreenClick', e);
  },

  onClickUp: function (e) {
    document.body.removeEventListener('click', this._onWorkspaceClick);
  }

});

module.exports = Workspace;



// WEBPACK FOOTER //
// ./src/views/Workspace.jsx